import { createSelector } from 'reselect';
import { getDeviationById } from '../deviations/selectors';
import { getCompositeId } from '../normalizr/schemas/deviation';
import { DeviationResourceType } from '../../types/deviation';
import { CommissionStatusCodes } from '../../types/commissions';
export const getCommissionById = (state, id)=>getDeviationById(state, getCompositeId(DeviationResourceType.COMMISSION, id));
export const getIsDeleted = createSelector([
    getCommissionById
], (deviation)=>{
    try {
        return deviation.commission.status === CommissionStatusCodes.STATUS_DELETED;
    } catch (e) {
        return false;
    }
});
export const getIsActive = createSelector([
    getCommissionById,
    getIsDeleted
], (deviation, isDeleted)=>{
    try {
        return !isDeleted && deviation.commission.status === CommissionStatusCodes.STATUS_ACTIVE;
    } catch (e) {
        return false;
    }
});

//# sourceMappingURL=selectors.js.map